module.exports = __webpack_public_path__ + "img/1479932545.552b9ed6.jpg";